import { render, staticRenderFns } from "./ButtonAppearance.vue?vue&type=template&id=bc1c8ba0&scoped=true&lang=pug"
import script from "./ButtonAppearance.vue?vue&type=script&lang=js"
export * from "./ButtonAppearance.vue?vue&type=script&lang=js"
import style0 from "./ButtonAppearance.vue?vue&type=style&index=0&id=bc1c8ba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1c8ba0",
  null
  
)

export default component.exports